<template>
  <v-container fluid fill-height justify-center>
    <v-col>
      <!-- CompanyCode -->
      <v-row no-gutters>
        <v-col cols="1" class="mt-3">
          <v-text-field class="mb-3" v-model="cliente.companyCode" dense readonly hide-details label="Codice Utente"
            outlined />
        </v-col>
      </v-row>

      <!-- Ragione Sociale - Indirizzo -->
      <v-row no-gutters>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.ragioneSociale" class="mr-10" hide-details dense label="Ragione Sociale"
            :readonly="readonly" clearable />
        </v-col>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.indirizzo" dense hide-details label="Indirizzo" :readonly="readonly"
            clearable />
        </v-col>
      </v-row>

      <!-- E-mail - P.Iva -->
      <v-row no-gutters>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.eMail" class="mr-10" dense hide-details label="E-mail" :readonly="readonly"
            clearable />
        </v-col>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.pIva" dense hide-details label="P.iva" :readonly="readonly" clearable />
        </v-col>
      </v-row>

      <!-- Telefono -->
      <v-row no-gutters>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.telefono" class="mr-10" hide-details label="Telefono/Cellulare"
            :readonly="readonly" dense clearable />
        </v-col>
      </v-row>

      <!-- Attività - Produttore/Trader -->
      <v-row no-gutters>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.attivita" class="mr-10" hide-details label="Attività" :readonly="readonly"
            dense clearable />
        </v-col>
        <v-col class="mt-3" cols="6">
          <v-text-field v-model="cliente.produttoreTrader" dense hide-details label="Produttore/Trader"
            :readonly="readonly" clearable />
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: "DatiUtente",

  props: {
    cliente: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
